module.exports = __webpack_public_path__ + "static/media/news-letter-bg.2e87bca4.jpg";